// extracted by mini-css-extract-plugin
module.exports = {"card_results":"situation-card_card_results__1vc3o","screenshots":"situation-card_screenshots__1F8cw","results_summary":"situation-card_results_summary__1kHqK"};